import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";
import type { TableSort } from "@/lib/adminTableSort";

export function SortableTableHeader<K extends string>({ column, label, sort, onSort, className }: {
  column: K; label: string; sort: TableSort<K> | null; onSort: (column: K) => void; className?: string;
}) {
  const direction = sort?.key === column ? sort.direction : "none";
  const Icon = direction === "ascending" ? ArrowUp : direction === "descending" ? ArrowDown : ArrowUpDown;
  return (
    <th scope="col" aria-sort={direction} className={className}>
      <button type="button" onClick={() => onSort(column)}
        aria-label={`${label}: sort ${direction === "ascending" ? "descending" : "ascending"}`}
        className="inline-flex min-h-9 items-center gap-2 rounded text-left font-semibold hover:text-foreground focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-sky-400">
        {label}<Icon aria-hidden="true" className="h-3.5 w-3.5 shrink-0" />
      </button>
    </th>
  );
}
